import React from "react";
import { Link } from "react-router-dom";

export default class ServiceOne extends React.Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="services-one-sec">
          <div className="container">
            <div className="sec-title text-center">
              <div className="sec-title__tagline">
                <span className="left"></span>
                <h6>Our Services</h6> <span className="right"></span>
              </div>
              <h2 className="sec-title__title">Our Professional Services</h2>
            </div>

            <div className="row">
              {/* Start Services One Single */}
              <div className="col-xl-4 col-lg-4">
                <div className="services-one__single">
                  <div
                    className="services-one__single-img"
                    style={{ height: "235px" }}
                  >
                    <img
                      src={
                        publicUrl + "assets/images/services/external-area.jpg"
                      }
                      alt=""
                    />
                  </div>

                  <div className="services-one__single-content">
                    <div className="services-one__single-content-title">
                      <h2>
                        <Link to={`/general-contracting`}>
                          Construction and Installation
                        </Link>
                      </h2>
                    </div>

                    <div className="services-one__single-content-bottom">
                      <p>
                        Transform your outdoor spaces with our expert
                        construction & installation services: patios, walkways,
                        kitchens, & more, creating lasting beauty &
                        functionality.
                      </p>

                      <div className="services-one__single-btn">
                        <Link
                          to={`/general-contracting`}
                          className="thm-btn"
                          data-text="Read More +"
                        >
                          Read More +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Services One Single */}

              {/* Start Services One Single */}
              <div className="col-xl-4 col-lg-4">
                <div className="services-one__single">
                  <div className="services-one__single-img">
                    <img
                      src={publicUrl + "assets/images/services/lareira.webp"}
                      alt=""
                    />
                  </div>

                  <div className="services-one__single-content">
                    <div className="services-one__single-content-title">
                      <h2>
                        <Link to={`/general-contracting`}>Fire Features</Link>
                      </h2>
                    </div>

                    <div className="services-one__single-content-bottom">
                      <p>
                        Enhance outdoor living with custom fire pits &
                        fireplaces, adding warmth, ambiance, and a focal point
                        to your gatherings.
                      </p>

                      <div className="services-one__single-btn">
                        <Link
                          to={`/general-contracting`}
                          className="thm-btn"
                          data-text="Read More +"
                        >
                          Read More +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Services One Single */}

              {/* Start Services One Single */}
              <div className="col-xl-4 col-lg-4">
                <div className="services-one__single">
                  <div className="services-one__single-img">
                    <img
                      src={
                        publicUrl +
                        "assets/images/services/steps-house.webp"
                      }
                      alt=""
                    />
                  </div>

                  <div className="services-one__single-content">
                    <div className="services-one__single-content-title">
                      <h2>
                        <Link to={`/general-contracting`}>
                          Restoration and Finishing
                        </Link>
                      </h2>
                    </div>

                    <div className="services-one__single-content-bottom">
                      <p>
                        Preserve stone structures with our restoration &
                        finishing services: pool coping, repairs, repointing,
                        ensuring they stand the test of time.
                      </p>

                      <div className="services-one__single-btn">
                        <Link
                          to={`/general-contracting`}
                          className="thm-btn"
                          data-text="Read More +"
                        >
                          Read More +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Services One Single */}
            </div>
          </div>
        </section>
      </>
    );
  }
}
